import axios from '../../../helpers/custom-axios';
import { notify, confirmation } from '../../../helpers/notifications';

export const createUserFilterField = async (user_filter_field) => {
  return axios
    .post('/manage/user_filter_fields', {
      user_filter_field,
    })
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const destroyUserFilterField = async (uff, callback) => {
  confirmation.destroy(async () => {
    return axios
      .delete(`/manage/user_filter_fields/${uff.id}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        console.error(error.response);
        callback(error);
      });
  });
};
